import { useKeycloak } from '@react-keycloak/web';
import { hasGodLike, type VianaTokenClaims } from '@viana-demos/types';

export interface AuthState {
  ready: boolean;
  authenticated: boolean;
  isGodLike: boolean;
  roles: string[];
  networks: string[];
  email: string | null;
  name: string | null;
  logout: () => void;
}

export function useAuth(): AuthState {
  const { keycloak, initialized } = useKeycloak();
  const claims = keycloak?.tokenParsed as VianaTokenClaims | undefined;
  const roles = claims?.realm_access?.roles ?? [];

  return {
    ready: initialized,
    authenticated: Boolean(keycloak?.authenticated),
    isGodLike: hasGodLike(roles),
    roles,
    networks: claims?.networks ?? [],
    email: claims?.email ?? null,
    name: claims?.name ?? claims?.preferred_username ?? null,
    logout: () => keycloak?.logout({ redirectUri: window.location.origin }),
  };
}
